module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8700/img/hubspot-tools-logo.png"